interface ChatActionPayload {
  type: string;
  payload?: any;
}

interface TableActionHandlers {
  handleBulkEmailClick?: (columnName: string, selectedLeads: any[]) => void;
  columns?: Array<{ name: string; [key: string]: any }>;
  filteredLeads?: any[];
  // Existing handlers from ProfessionalTable
  handleFindMoreResults?: (actionParameters?: any) => void;
  handleAddColumn?: (columnName?: string, enrichmentType?: string) => void;
}

export const handleTableAction = (
  action: ChatActionPayload,
  handlers: TableActionHandlers
) => {
  // Find email columns to determine which leads have emails
  const emailColumns = handlers.columns?.filter(col => 
    col.name.toLowerCase().includes('email')
  ) || [];
  switch (action.type) {
    case 'find_more_results':
      if (handlers.handleFindMoreResults) {
        handlers.handleFindMoreResults(action.payload?.actionParameters);
      } else {
        console.warn('handleFindMoreResults not available');
      }
      break;
      
    case 'enrich_column':
      if (handlers.handleAddColumn) {
        const columnName = action.payload?.actionParameters?.column;
        const enrichmentType = action.payload?.actionParameters?.enrichmentType;
        handlers.handleAddColumn(columnName, enrichmentType);
      } else {
        console.warn('handleAddColumn not available');
      }
      break;
      
    case 'show_email_modal':
      if (emailColumns.length > 0 && handlers.handleBulkEmailClick && handlers.filteredLeads) {
        // Determine which email column to use - prefer suggested column if available
        const suggestedEmailData = action.payload?.suggestedEmailData;
        let emailColumnToUse = emailColumns[0].name; // default to first email column

        if (suggestedEmailData?.suggestedEmailColumn) {
          // Check if suggested column exists
          const suggestedColumn = handlers.columns?.find(col =>
            col.name.toLowerCase() === suggestedEmailData.suggestedEmailColumn.toLowerCase()
          );
          if (suggestedColumn) {
            emailColumnToUse = suggestedColumn.name;
          }
        }

        // Use suggested email column and all filtered leads
        handlers.handleBulkEmailClick(emailColumnToUse, handlers.filteredLeads);
      }
      break;
      
    default:
      console.warn(`Unhandled table action type: ${action.type}`);
  }
};